/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Help16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0m0 1a7 7 0 100 14A7 7 0 008 1m-.256 10a.75.75 0 01.533.222.744.744 0 010 1.063.766.766 0 01-.533.215.771.771 0 01-.295-.057.73.73 0 01-.392-.394.755.755 0 01-.057-.296.757.757 0 01.213-.531.704.704 0 01.236-.162.755.755 0 01.295-.06m.221-8c.363 0 .699.057 1.01.17.309.113.577.272.801.479.226.206.403.457.531.752.129.295.193.627.193.996 0 .374-.052.697-.155.967a2.79 2.79 0 01-.393.71 3.177 3.177 0 01-.516.532l-.527.425a3.357 3.357 0 00-.424.398.798.798 0 00-.203.443L8.158 10h-.841l-.082-1.225a.963.963 0 01.118-.58c.095-.163.222-.318.378-.463.156-.145.329-.288.517-.427a4.17 4.17 0 00.526-.47c.163-.171.3-.366.411-.586.11-.22.165-.48.165-.785a1.36 1.36 0 00-.434-1.015 1.396 1.396 0 00-.472-.276 1.738 1.738 0 00-.582-.096c-.28 0-.52.037-.719.11-.201.075-.37.156-.507.245a2.843 2.843 0 00-.334.243c-.085.073-.155.11-.21.11-.114 0-.204-.056-.269-.17L5.5 4.062c.142-.142.299-.278.472-.406a3.327 3.327 0 011.225-.571c.237-.057.492-.085.768-.085"
        />
    </AccessibleSVG>
);

export default Help16;
